<div [style.maxWidth.px]="maxWidth" [style.maxHeight.px]="maxHeight" class="w-100 h-100">
    <p-chart [attr.data-testid]="uid" type="{{ chartType }}" [data]="data" [options]="options" [width]="width" [height]="height" [responsive]="responsiveLayout"></p-chart>
</div>
